export const termsData = [
  {
    title: "Parts of this Agreement",
    description:
      'This Agreement consists of the following terms and conditions \
    ("General Terms") and terms specific to individual services ("Service \
    Specific Terms"). In the event of a conflict, the Service Specific \
    Terms shall prevail.',
  },
  {
    title: "Acceptance of the Agreement",
    description:
      "You must be of legal age to enter into a binding agreement to accept this Agreement. If you do not agree to the General Terms, do not use any of our Services. Acceptance can be indicated by checking a checkbox, clicking a button, or by actually using the Services.",
  },
  {
    title: "Description of Service",
    description:
      'TheX provides cloud-based software and applications for businesses, including offline and mobile applications ("Service" or "Services"). These may be used for personal or internal business purposes. You are responsible for obtaining Internet access and compatible equipment to use the Services',
  },
  {
    title: "Data Backup and Security",
    description:
      "TheX is not responsible for any data backup. Customers are solely responsible for maintaining backups of their data. Furthermore, TheX shall not be held liable for any data loss or damage caused by hacker attacks. TheX is only responsible for providing reasonable security measures to protect your data.",
  },
  {
    title: "Liability",
    description:
      "TheX's liability is limited to the subscription amount paid by the customer for the past six (6) months prior to any claim. Under no circumstances will TheX be liable for indirect, incidental, punitive, or consequential damages.",
  },
  {
    title: "Beta Service",
    description:
      'TheX may offer closed or open beta services ("Beta Services") for testing purposes. TheX retains the right to determine the testing duration and success of the Beta Services. Beta Services can be discontinued at any time without notice or liability.',
  },
  {
    title: "Free Trial",
    description:
      "If you register for a free trial, the Services will be provided free of charge until the earlier of (i) the trial's end, (ii) subscription commencement, or (iii) termination by TheX. Data and customizations made during the trial may be lost unless a subscription is purchased or data is exported before the trial ends. Services during the trial are provided as-is, without warranty or liability.",
  },
  {
    title: "User Sign-Up Obligations",
    description:
      "To access or use the Services, you must sign up for a user account by providing accurate and complete information. Failure to do so may result in account termination.",
  },
  {
    title: "Restrictions on Use",
    description: "You shall not:",
    subList: [
      "Transfer or share the Services.",
      "Reverse-engineer the Services",
      "Use the Services in any manner that violates applicable laws, promotes illegal activities, or threatens the unity, integrity, or sovereignty of India.",
      "Transmit viruses or harmful code.",
      "Remove or obscure proprietary notices.",
    ],
  },
  {
    title: "Spamming and Illegal Activities",
    description:
      "You are solely responsible for all content transmitted via the Services. Prohibited activities include transmitting illegal, harmful, defamatory, or objectionable content or engaging in spamming or phishing activities. Violation may result in account termination.",
  },
  {
    title: "Third-Party Applications",
    description:
      'The Services may integrate with third-party applications ("Third-Party Applications"). TheX is not liable for any issues or losses caused by these applications. Access and use of such applications are subject to their respective terms and conditions.',
  },
  {
    title: "Fees and Payments",
    description:
      "Services are offered under subscription plans. Payments for plans under a year must be made via credit card, and subscriptions automatically renew unless canceled at least seven (7) days prior. Any changes to fees will apply only after the current billing cycle.",
  },
  {
    title: "Organization Accounts and Administrators",
    description:
      "If you create an organization account, you may designate administrators responsible for managing the account. TheX is not liable for account administration or internal management issues.",
  },
  {
    title: "Personal Information and Privacy",
    description:
      "Your personal information is governed by TheX's Privacy Policy. You are responsible for maintaining the confidentiality of your account details and promptly notifying TheX of any unauthorized access.",
  },
  {
    title: "Communications from TheX",
    description:
      "The Services may include communications such as service announcements and administrative messages. You may opt-out of newsletters but not essential service communications.",
  },
  {
    title: "Complaints and Grievances",
    description:
      "If TheX receives a complaint regarding your use of the Services, you must respond within 10 days. Failure to do so may result in the disclosure of your contact details to the complainant for legal recourse. For grievances, contact TheX’s Grievance Officer via email at support@thex.biz or by phone at +916282000287.",
  },
  {
    title: "Inactive User Accounts",
    description:
      "TheX reserves the right to terminate inactive accounts (no activity for 120 days). Customers will be notified beforehand and allowed to back up their data.",
  },
  {
    title: "Hosting Location",
    description:
      "The hosting location is determined by your region during sign-up. TheX may migrate your account if necessary. You must not mask your IP address during sign-up.",
  },
  {
    title: "Data Ownership",
    description:
      "You own the content created or stored by you. TheX does not have the right to use your content for commercial purposes without your explicit consent. However, TheX may access your content as required to provide Services.",
  },
  {
    title: "User-Generated Content",
    description:
      "You are responsible for any content you publish via the Services. You agree not to post or share copyrighted material without proper authorization.",
  },
  {
    title: "Trademark",
    description:
      "TheX trademarks, including logos, may not be used without prior permission.",
  },
  {
    title: "Disclaimer of Warranties",
    description:
      'The Services are provided "as-is" and "as-available." TheX disclaims all warranties, including those of merchantability and fitness for a particular purpose. TheX does not guarantee uninterrupted, secure, or error-free Services.',
  },
  {
    title: "Indemnification",
    description:
      "You agree to indemnify TheX against any claims arising from your violation of the Agreement, applicable laws, or third-party rights",
  },
  {
    title: "Governing Law",
    description:
      "This Agreement is governed by the laws of India. Any disputes shall be adjudicated exclusively by the courts in Bangalore.",
  },
  {
    title: "Suspension and Termination",
    description:
      "TheX may suspend or terminate your account for violations of this Agreement or inactivity. Customers may also terminate accounts, in which case data will be deleted.",
  },
  {
    title: "Modification of Terms",
    description:
      "TheX reserves the right to modify the Agreement with notice. Continued use of the Services after modifications constitutes acceptance of the changes.",
  },
  {
    title: "End of Terms of Service",
    description:
      `For any questions or concerns, contact <a href="mailto:support@ledgerx.biz">support@ledgerx.biz</a>.`,
  },
];
